import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import classNames from './Channels.css'
import { picassoFetch } from '../utils/fetch'
import { pluralize, formatMinutes } from '../utils/string'
import { userHasPerm } from '../utils/auth'
import { createImageGetter } from '../utils/images'
import { fetchQueues } from '../redux/queues'
import LoadingSpinner from '../components/LoadingSpinner'
import Modal from '../components/modals/Modal'
import UserChecklist from '../components/UserChecklist'
import ConfirmButtons from '../components/ConfirmButtons'
import Icon from '../components/Icon'
import ErrorMessage from '../components/ErrorMessage'
import ShareButton from '../components/ShareButton'
import DropMenu from '../components/DropMenu'
import Toggle from '../components/Toggle'
import ChannelInfo from '../components/present/ChannelInfo'
import ChannelTabs from '../components/channels/ChannelTabs'
import EmptyNotice from '../components/EmptyNotice'

class Channels extends Component {
  state = {
    channels: null,
    channelsError: null,
    shareChannel: null,
    usersChecked: null,
    renameChannel: null,
    editChannelQueue: null,
    fetching: false,
    showCreateChannelModal: false,
    showInfo: null,
    addingQueueToChannel: false
  }
  componentDidMount () {
    const { channels } = this.state
    if (!channels) {
      this.fetchChannels()
    }
    const { queues, fetchQueues } = this.props
    if (!queues) {
      fetchQueues(this.props.dispatch)
    }
  }
  fetchChannels = () => {
    this.setState({
      channelsError: null,
      fetching: true
    })
    this.props.fetchChannels(this.props.dispatch).then(data => {
      this.setState({
        channels: data.channels,
        fetching: false
      })
    }, e => {
      this.setState({
        channelsError: e,
        fetching: false
      })
    })
  }
  updateEntireChannel = channel => {
    const index = this.state.channels.findIndex(c => c.id === channel.id)
    this.setState({
      channels: [
        ...this.state.channels.slice(0, index),
        channel,
        ...this.state.channels.slice(index + 1)
      ]
    })
  }
  updateChannel = (id, key, value, deep) => {
    const channels = this.state.channels.slice(0)
    const index = channels.findIndex(c => c.id === id)
    if (typeof deep !== 'undefined') {
      if (!channels[index][key]) {
        channels[index][key] = {}
      }
      channels[index][key][value] = deep
    } else {
      channels[index][key] = value
    }
    this.setState({ channels })
  }
  updateChannelData = (id, key, value) => {
    if (key === 'time_offset' && value === 'device') {
      // Use device offset
      value = new Date().getTimezoneOffset() * -60
    }
    this.updateChannel(id, 'data', key, value)     // Update local state
    this.props.updateChannel(id, { [key]: value }) // Send update to picasso
  }
  onClickDeleteChannel = (id, mine) => {
    if (window.confirm(`Are you sure you want to ${mine ? 'delete' : 'remove'} this channel?`) === false) {
      return
    }
    const { deleteChannel, channelAction } = this.props
    if (mine) {
      deleteChannel(id)
    } else {
      channelAction(id, 'unshare_user')
    }
    this.setState({
      channels: this.state.channels.filter(c => c.id !== id)
    })
  }
  onSubmitCreateChannel = e => {
    e.preventDefault()
    this.setState({ creatingChannel: true })
    const name = this.refs.name.value
    const queueID = this.refs.createChannelQueue.value
    this.props.createChannel(name, queueID).then(data => {
      this.setState({
        channels: [ ...this.state.channels, data.channel ],
        creatingChannel: false,
        showCreateChannelModal: false
      })
    })
  }
  onSubmitRenameChannel = e => {
    e.preventDefault()
    const id = this.state.renameChannel
    const name = this.refs.rename.value
    this.props.renameChannel(id, name)
    this.updateChannel(id, 'name', name)
    this.setState({ renameChannel: null })
  }
  onConfirmShareChannel = () => {
    const { shareChannel, usersChecked } = this.state
    this.props.updateChannel(shareChannel.id, { members: usersChecked })
    this.updateChannel(shareChannel.id, 'members', usersChecked)
    this.setState({
      shareChannel: null,
      usersChecked: null
    })
  }
  onClickShareChannel = channel => {
    this.setState({
      shareChannel: channel,
      usersChecked: channel.data ? channel.members.map(s => parseInt(s)) : []
    })
  }
  getLocation () {
    if (!window.navigator.geolocation) {
      return Promise.resolve({})
    }
    return new Promise(resolve => {
      window.navigator.geolocation.getCurrentPosition(location => {
        resolve({
          lat: location.coords.latitude,
          lon: location.coords.longitude
        })
      }, () => resolve({}))
    })
  }
  addQueueToChannel = (channelID, queueID) => {
    this.setState({ addingQueueToChannel: true })
    this.getLocation().then(position => {
      return this.props.sendQueueToChannel(channelID, queueID, position)
    }).then(
      data => {
        this.setState({
          addingQueueToChannel: false,
          editChannelQueue: null
        })
        this.updateEntireChannel(data.channel)
      },
      () => {
        this.setState({ addingQueueToChannel: false, editChannelQueue: null })
        window.alert('There was an error adding to the channel')
      }
    )
  }
  onClickToggleChannelEnabled = channel => {
    if (channel.disabled) {
      this.props.enableChannel(channel.id)
      this.updateChannel(channel.id, 'disabled', false)
    } else {
      this.props.disableChannel(channel.id)
      this.updateChannel(channel.id, 'disabled', true)
    }
  }
  onClickClearPlayNow = id => {
    this.props.channelAction(id, '`clear_queue_externals`', { origin: 'play_now' })
    this.updateChannel(id, 'external_count', 'play_now', 0)
  }
  onClickClearPlayNext = id => {
    this.props.channelAction(id, '`clear_queue_externals`', { origin: 'play_next' })
    this.updateChannel(id, 'external_count', 'play_next', 0)
  }
  onClickResetChannel = id => {
    this.props.channelAction(id, 'reset_queue').then(data => {
      this.updateEntireChannel(data.channel)
    })
    this.setState({
      showInfo: null
    })
  }
  onToggleSkip = (channel, id) => {
    this.props.channelAction(channel.id, 'skip_album', { album_id: id }).then(data => {
      this.updateEntireChannel(data.channel)
    })
  }
  onToggleUnskip = (channel, id) => {
    this.props.channelAction(channel.id, 'unmute_album', { album_id: id }).then(data => {
      this.updateEntireChannel(data.channel)
    })
  }
  renderChannelName (channel, mine, owner) {
    const shared = !mine && owner ? <span> shared by {owner.name}</span> : null
    const stopped = !channel.data || channel.data._state === 'stopped'
    const onClickStop = () => {
      this.props.channelAction(channel.id, 'deactivate_channel')
      this.updateChannel(channel.id, 'data', '_state', 'stopped')
    }
    const onClickPlay = () => {
      this.props.channelAction(channel.id, 'activate_channel')
      this.updateChannel(channel.id, 'data', '_state', 'playing')
    }
    return (
      <div>
        <div className={classNames.channelName}>
          {channel.name}{shared}
          {mine &&
            <button onClick={stopped ? onClickPlay : onClickStop} className={classNames.channelToggle}>
              <Toggle value={!stopped} /> Channel {stopped ? 'off' : 'on'}
            </button>
          }
        </div>
      </div>
    )
  }
  renderControls (channel, mine) {
    const onClick = (event, newState) => {
      if (['play_next_album', 'play_queue', 'pause_queue'].indexOf(event) !== -1) {
        this.props.channelAction(channel.id, event)
      } else {
        this.props.channelEvent(channel.id, event)
      }
      if (newState) {
        this.updateChannel(channel.id, 'data', '_state', newState)
      }
    }
    const controlsDisabled = !channel.data || !channel.data._state || channel.data._state === 'stopped'
    const controlClass = controlsDisabled ? classNames.controlDisabled : classNames.control

    let progressWidth = 0
    if (channel.progress) {
      const played = channel.progress.duration_played
      const total = channel.progress.duration
      progressWidth = Math.round(played / total * 100)
    }

    const looped = channel.data && channel.data.loop

    const renderControl = (icon, onClick, size = 20) => (
      <button onClick={onClick} className={controlClass}>
        <Icon icon={icon} size={size} />
        {icon === 'restart' && <div>Reset</div>}
      </button>
    )

    return (
      <div className={classNames.controls}>
        <div className={classNames.progressWrapper}>
          <div className={classNames.progressBar} style={{ width: `${Math.min(100, progressWidth)}%` }} />
        </div>
        <div className={classNames.controlButtons}>
          <button onClick={() => this.onClickResetChannel(channel.id)} className={classNames.control} disabled={!mine}>
            <Icon icon='restart' size={16} />
            <div>Reset</div>
          </button>
          {renderControl('skip-back', () => onClick('prev'))}
          {renderControl('rewind', () => onClick('prev-image'))}
          {channel.data && channel.data._state === 'paused'
            ? renderControl('play', () => onClick('play_queue', 'playing'))
            : renderControl('pause', () => onClick('pause_queue', 'paused'))
          }
          {renderControl('forward', () => onClick('next-image'))}
          {renderControl('skip', () => onClick('play_next_album'))}
          <button onClick={() => this.updateChannelData(channel.id, 'loop', !looped)} className={looped ? classNames.controlActive : classNames.control} disabled={!mine}>
            <Icon icon='loop' size={16} />
            <div>{looped ? 'Looped' : 'Loop'}</div>
          </button>
        </div>
      </div>
    )
  }
  renderRenameForm (channel) {
    return (
      <form onSubmit={this.onSubmitRenameChannel}>
        <input
          ref='rename'
          type='text'
          defaultValue={channel.name}
          placeholder='New channel name'
          className={classNames.renameInput}
          autoFocus
        />
        <button
          type='button'
          className={classNames.cancelButton}
          onClick={() => this.setState({ renameChannel: null })}
        >
          Cancel
        </button>
        <input
          type='submit'
          value='Rename'
          className={classNames.renameButton}
        />
      </form>
    )
  }
  renderTools (channel, mine) {
    return (
      <div className={classNames.tools}>
        <button key='dots' onClick={() => this.setState({ dropMenuOpen: channel.id })} className={classNames.tool}>
          <Icon icon='dots' />
        </button>
        <DropMenu
          open={this.state.dropMenuOpen === channel.id}
          closeMenu={() => this.setState({ dropMenuOpen: null })}
          style={{ marginTop: '10px' }}
          items={[
            {
              text: channel.disabled ? 'Enable Current Shares' : 'Disable Current Shares',
              onClick: () => this.onClickToggleChannelEnabled(channel),
              shouldShow: mine
            },
            {
              text: 'Debug Channel',
              href: `/present/${channel.id}?debug=1`,
              shouldShow: mine
            },
            {
              text: 'Rename Channel',
              onClick: () => this.setState({ renameChannel: channel.id }),
              shouldShow: mine
            },
            {
              text: mine ? 'Delete Channel' : 'Remove Shared Channel',
              onClick: () => this.onClickDeleteChannel(channel.id, mine)
            }
          ]}
        />
      </div>
    )
  }
  renderChannelQueue (channel, mine) {
    const { editChannelQueue, addingQueueToChannel } = this.state
    const onAddQueue = e => this.addQueueToChannel(channel.id, this.refs.queue.value)
    const onClickChangeQueue = () => {
      this.setState({ editChannelQueue: channel.id },
        () => {
          if (channel.data) {
            this.refs.queue.value = channel.data.id
          }
        }
      )
    }
    const onClickCancel = () => this.setState({ editChannelQueue: null })
    const onClickClear = () => {
      if (window.confirm('Are you sure you want to clear this channel?')) {
        this.props.channelAction(channel.id, 'remove_queue')
        this.updateChannel(channel.id, 'data', undefined)
        this.updateChannel(channel.id, 'progress', undefined)
      }
    }
    const hasQueue = channel.data && channel.data._id
    const infoOpen = this.state.showInfo === channel.id
    const upNext = channel.data && this.getPlayingNext(channel)
    const nowPlayingText = channel.state === 'playing' ? 'Now playing' : 'Currently paused'
    return (
      <div>
        {editChannelQueue !== channel.id && !hasQueue &&
          <button className={classNames.addQueueButton} onClick={onClickChangeQueue} disabled={!mine}>
            {mine ? 'Add Queue' : 'No Queue'}
          </button>
        }
        {editChannelQueue !== channel.id && hasQueue &&
          <div className={classNames.channelQueue}>
            {/*mine &&
              <button onClick={onClickChangeQueue} className={classNames.iconButton}>
                <Icon icon='edit' size={18} />
              </button>
            */}
            <div className={classNames.channelQueueName}>
              {channel.data.name || channel.name}
            </div>
            {channel.progress &&
              <div className={classNames.channelQueueDuration}>
                {pluralize(channel.progress.total_images, 'image')}, {formatMinutes(channel.progress.duration / 60)}
                <br className={classNames.linkButtonLineBreak} />
                {mine && channel.data && channel.data.id &&
                  <Link to={`/queues/${channel.data.id}`} className={classNames.linkButton}>
                    Edit Queue
                  </Link>
                }
              </div>
            }
            {channel.data && channel.data.playlists && this.state.showInfo !== channel.id &&
              <div className={classNames.playingNow}>
                {nowPlayingText}: <strong>{this.getPlayingNow(channel)}</strong>
                <br />
                {upNext &&
                  <span>
                    Up next: <strong>{this.getPlayingNext(channel)}</strong>
                  </span>
                }
              </div>
            }
            {infoOpen &&
              <ChannelInfo
                data={channel.queue}
                conflicts={[]}
                onSkip={e => this.onToggleSkip(channel, e.target.value)}
                onUnskip={e => this.onToggleUnskip(channel, e.target.value)}
                getImageSource={this.props.getImageSource}
                isOwner={mine}
              />
            }
            {channel.data && channel.data.name &&
              <div className={classNames.channelQueueTopRight}>
                {mine &&
                  <button onClick={onClickClear} className={classNames.iconButton} disabled={infoOpen}>
                    <Icon icon='close' />
                  </button>
                }
                <br />
                <button className={classNames.linkButton} onClick={() => this.setState({ showInfo: infoOpen ? null : channel.id })}>
                  {infoOpen ? 'Hide Info' : 'Show Info'}
                </button>
              </div>
            }
            {mine &&
              <div className={classNames.channelQueueBottomRight}>
                {channel.progress &&
                  <div className={classNames.timeRemaining}>
                    {formatMinutes((channel.progress.duration - channel.progress.duration_played) / 60).replace('minute', 'min')} remaining
                  </div>
                }
              </div>
            }
          </div>
        }
        {editChannelQueue === channel.id &&
          <div>
            <select ref='queue' className={classNames.addQueueSelect} defaultValue=''>
              <option disabled value=''>Choose a queue</option>
              {this.props.queues.map(queue => (
                <option key={queue.id} value={queue.id}>{queue.name}</option>
              ))}
            </select>
            <button onClick={onClickCancel} className={classNames.cancelButton}>
              Cancel
            </button>
            <button onClick={onAddQueue} disabled={addingQueueToChannel} className={classNames.renameButton}>
              {addingQueueToChannel ? 'Updating…' : 'Update'}
            </button>
          </div>
        }
      </div>
    )
  }
  getPlayingNow = channel => {
    for (let playlist of channel.data.playlists) {
      for (let album of playlist.albums) {
        if (album._state === 'playing' || album._state === 'paused') {
          return album.name
        }
      }
    }
    return 'None'
  }
  getPlayingNext = channel => {
    if (!channel || !channel.data || !channel.data.playlists) {
      return null
    }
    for (let playlist of channel.data.playlists) {
      for (let album of playlist.albums) {
        if (album._state === 'present' || album._state === 'external') {
          return album.name
        }
      }
    }
    return null
  }
  renderChannel = channel => {
    const { renameChannel, editChannelQueue } = this.state

    const mine = this.props.me.id === parseInt(channel.owner_id)
    const owner = this.props.getOwner(channel)

    if (!this.props.canCreateChannels && mine) {
      // Do not display own channels for users who cannot create them
      return null
    }

    return (
      <li key={channel.id} className={classNames.channel}>
        {renameChannel !== channel.id &&
          this.renderTools(channel, mine)
        }
        {renameChannel === channel.id
          ? this.renderRenameForm(channel)
          : this.renderChannelName(channel, mine, owner)
        }
        <ChannelTabs
          channel={channel}
          updateData={(key, value) => this.updateChannelData(channel.id, key, value)}
          mine={mine}
          clients={channel.clients || []}
          onClickShare={e => {
            e.preventDefault()
            this.onClickShareChannel(channel)
          }}
        />
        {this.renderChannelQueue(channel, mine)}
        {editChannelQueue !== channel.id &&
          this.renderControls(channel, mine)
        }
      </li>
    )
  }
  renderShareModal (channel) {
    const clients = channel.clients || []
    const { usersChecked } = this.state
    const myClients = clients.filter(c => parseInt(c.user_id) === this.props.me.id)
    const getExtra = id => (
      <div>
        {clients
          .filter(c => parseInt(c.user_id) === id)
          .map(renderClient)
        }
      </div>
    )
    const onGeneratePublic = () => {
      if (this.state.usersChecked.indexOf(0) === -1) {
        this.setState({
          usersChecked: this.state.usersChecked.concat(0)
        })
      }
    }
    return (
      <Modal title='Share Channel'>
        <div className={classNames.page}>
          {myClients.length !== 0 &&
            <div className={classNames.heading}>
              Your clients viewing {channel.name}
            </div>
          }
          {myClients.map(renderClient)}
          {myClients.length !== 0 && <hr />}
          <button onClick={() => this.onClickToggleChannelEnabled(channel)} className={classNames.disableToggle}>
            <Toggle value={channel.disabled} />
            {channel.disabled ? ' Channel shares disabled' : 'Temporarily disable channel shares'}
          </button>
          <UserChecklist
            value={usersChecked}
            onChange={users => this.setState({ usersChecked: users })}
            getExtra={getExtra}
            showExternalUsers
            channelUsersOnly
            appendToExternal={
              <div>
                <ShareButton
                  style={{ textAlign: 'left' }}
                  path={`/present/${channel.id}`}
                  hideDownloadToggle
                  onFetch={onGeneratePublic}
                  allowPrivileged={true}
                />
              </div>
            }
            externalSubtitle='Anyone with a public link will have access to the channel'
          />
          <ConfirmButtons
            onConfirm={this.onConfirmShareChannel}
            onCancel={() => this.setState({ shareChannel: null, usersChecked: null })}
          />
        </div>
      </Modal>
    )
  }
  renderCreateModal () {
    const { queues } = this.props
    return (
      <Modal title='Create Channel' onClose={() => this.setState({ showCreateChannelModal: false })}>
        <div className={classNames.page}>
          <form onSubmit={this.onSubmitCreateChannel}>
            <label>
              Name
              <input
                ref='name'
                type='text'
                placeholder='eg My Photo Frame'
                className={classNames.createInput}
                required
              />
            </label>
            <label>
              Queue
              <select ref='createChannelQueue' defaultValue=''>
                <option disabled value=''>Choose a queue</option>
                {queues.map(queue => (
                  <option key={queue.id} value={queue.id}>{queue.name}</option>
                ))}
              </select>
            </label>
            <div className={classNames.buttons}>
              <button
                type='button'
                onClick={() => this.setState({ showCreateChannelModal: false })}
                className={classNames.cancelButton}>
                Cancel
              </button>
              <input
                type='submit'
                value={this.state.creatingChannel ? 'Creating…' : 'Create'}
                className={classNames.createButton}
                disabled={this.state.creatingChannel}
              />
            </div>
          </form>
          {this.state.creatingChannel &&
            <LoadingSpinner />
          }
        </div>
      </Modal>
    )
  }
  renderEmpty () {
    if (this.props.canCreateChannels) {
      return (
        <EmptyNotice
          heading='Create channels of photo presentations to display on external screens'
          text='Connect to photo frames, create URLs for others, and control them all here.'
        />
      )
    }
    return (
      <EmptyNotice
        heading='Shared channels will appear here'
        text='Here’s where other users can present their images to you.'
      />
    )
  }
  render () {
    const { queues, canCreateChannels } = this.props
    const { channels, channelsError, shareChannel, fetching } = this.state
    if (channelsError) {
      return (
        <ErrorMessage
          message='There was an error fetching channels'
          onRetry={this.fetchChannels}
        />
      )
    }
    if (!queues || !channels) {
      return <LoadingSpinner />
    }
    const myChannels = channels.filter(c => this.props.me.id === parseFloat(c.owner_id))
    const sharedChannels = channels.filter(c => this.props.me.id !== parseFloat(c.owner_id))
    return (
      <div className={classNames.page}>
        {channels.length === 0 &&
          this.renderEmpty()
        }
        {canCreateChannels &&
          <button onClick={() => this.setState({ showCreateChannelModal: true })} className={classNames.addButton}>
            Create new channel
          </button>
        }
        {myChannels.length !== 0 &&
          <ul>
            {myChannels.map(this.renderChannel)}
          </ul>
        }
        {sharedChannels.length !== 0 &&
          <h2>Channels shared with me</h2>
        }
        {sharedChannels.length !== 0 &&
          <ul>
            {sharedChannels.map(this.renderChannel)}
          </ul>
        }
        {myChannels.length !== 0 &&
          <div>
            <div className={classNames.heading}>
              Notes
            </div>
            <ul className={classNames.notes}>
              <li>Playing a stopped channel will immediately start presenting the queue to all connected clients</li>
              <li>Stopping a channel will pause the queue until a channel is played again</li>
            </ul>
          </div>
        }
        {channels.length !== 0 &&
          <button onClick={this.fetchChannels} className={classNames.refreshButton}>
            {fetching ? 'Refreshing…' : 'Refresh channels'}
          </button>
        }
        {shareChannel &&
          this.renderShareModal(shareChannel)
        }
        {this.state.showCreateChannelModal &&
          this.renderCreateModal()
        }
      </div>
    )
  }
}

function renderClient (client) {
  return (
    <div className={classNames.client}>
      {client.os} - {client.browser}
    </div>
  )
}

const mapStateToProps = ({ queues, entities, auth }) => ({
  entities,
  me: auth.user,
  queues: queues.data && queues.data.map(id => entities.queues[id]),
  canCreateChannels: userHasPerm(auth.user, 'create_channels'),
  fetchQueues: dispatch => dispatch(fetchQueues()),
  fetchChannels: dispatch => picassoFetch(auth, 'list_channels', undefined, dispatch),
  createChannel: (name, queueID) => picassoFetch(auth, 'create_channel', {
    name,
    queue_id: queueID || undefined,
    time_offset: new Date().getTimezoneOffset() * -60
  }),
  deleteChannel: id => picassoFetch(auth, 'remove_channel', { channel_id: id }),
  sendQueueToChannel: (channelID, queueID, position) => picassoFetch(auth, 'set_queue', {
    channel_id: channelID,
    queue_id: queueID,
    location: position.lat ? `${position.lat},${position.lon}` : undefined,
    time_offset: new Date().getTimezoneOffset() * -60
  }),
  renameChannel: (id, name) => picassoFetch(auth, 'rename_channel', {
    channel_id: id,
    name
  }),
  updateChannel: (id, values) => picassoFetch(auth, 'update_channel', {
    channel_id: id,
    update: values
  }),
  channelAction: (id, action, extra) => picassoFetch(auth, action, { channel_id: id, ...extra }),
  channelEvent: (id, event) => picassoFetch(auth, 'send_event', { channel_id: id, event }),
  disableChannel: id => picassoFetch(auth, 'disable_channel', { channel_id: id }),
  enableChannel: id => picassoFetch(auth, 'enable_channel', { channel_id: id }),
  getOwner: channel => entities.users[channel.owner_id],
  getImageSource: createImageGetter(auth)
})

export default connect(mapStateToProps, null)(Channels)



// WEBPACK FOOTER //
// ./src/pages/Channels.js